import React from "react";
import styled from "styled-components";
import {Button} from "../../../../components/ui-elements/Button";

type Props = {
  className?: string
  primaryColor: string
}

export const ScrollButton: React.FC<Props> = (props) => {
  return <StyledComponent {...props} />;
};


const Component: React.FC<Props> = ({
                                      className,
                                      primaryColor,
                                    }) => {
  
  return (
    <div className={className}>
      <div className="fixed_bottom">
        <div className="scroll_button">
          <Button
            color={primaryColor}
            onClick={() => {
              const targetTop = document.getElementById("targetTop");
              if (targetTop) {
                targetTop.scrollIntoView({behavior: "smooth"});
              }
            }}
            invert
          >
            ↑
          </Button>
        </div>
      </div>
    </div>
  );
};

const StyledComponent = styled(Component)`
  display: flex;
  justify-content: flex-end;

  > .fixed_bottom {
    display: flex;

    > .scroll_button {
      width: 48px;
      margin-right: 16px;
    }
  }
`;
